module.exports = __webpack_public_path__ + "img/pic4.3e3e01b4.jpg";